import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { ShowException } from 'store/Application/appActions'
import { newProjectActions } from '../newProjectReducer'
import { bomItemSelector } from '../selectors/bomItemSelector'

export const toggleManufacturabilityFlag = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'boM/toggleManufacturabilityFlag',
  async ({ bomItemId }: { bomItemId: string }, thunkAPI) => {
    const bomItemController = new BomItemController()

    const bomItem = bomItemSelector(
      thunkAPI.getState(),
      bomItemId
    ) as PartTypeRow

    try {
      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: bomItemId,
          isManufacturable: !bomItem.isManufacturable,
        })
      )

      thunkAPI.dispatch(newProjectActions.updateHeadersFilteredParts())

      return await bomItemController.SwitchManufacturabilityFlag(bomItemId)
    } catch (err) {
      ShowException('project', err)
      throw err
    }
  }
)
